import * as localforage from "localforage";
import axios from "axios";
import { flatArrList, sortArrByName } from "../helpers/arrayHandlers";

export const getCompaniesAPI = async () => {
  const companyId = await localforage.getItem("companyId");
  let response = await axios({
    url: `/api/v2/companies`,
    method: "GET",
    params: {
      company_id: companyId
    }
  });
  const companyArr = response.data.companies;
  const flattenCompanyArr = flatArrList(companyArr);
  const sortedFlattenCompanyArr = sortArrByName(flattenCompanyArr);
  return sortedFlattenCompanyArr;
};
